"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var updateMultiple = function updateMultiple(option, wasSelected, selectedOptions) {
  if (wasSelected) {
    return selectedOptions.filter(function (_ref) {
      var value = _ref.value;
      return value !== option.value;
    });
  }

  return [option].concat((0, _toConsumableArray2.default)(selectedOptions));
};

var selectionChanger = function selectionChanger(option, wasSelected) {
  var removeSearch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (state, props) {
    return {
      selectedOptions: props.multiple ? updateMultiple(option, wasSelected, state.selectedOptions) : [option],
      searchValue: removeSearch ? '' : state.searchValue,
      expanded: props.multiple
    };
  };
};

var _default = selectionChanger;
exports.default = _default;